/**
 * Configuration de l'application BTPal
 * URLs des APIs control plane et tenant
 */

export const config = {
    apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3001',

    // Paramètres par défaut (peuvent être surchargés par variables d'environnement)
    defaultCriticalThreshold: Number(import.meta.env.VITE_CRITICAL_THRESHOLD) || 5000,
    forecastDays: Number(import.meta.env.VITE_FORECAST_DAYS) || 90,

    // Pagination
    defaultPageSize: 20,
    maxPageSize: 100,
} as const;

export type Config = typeof config;
